import { ComedianRow } from "@/data/comedians";
import Image from "next/image";
import Link from "next/link";
import { cn } from "@/components/common/utils";
import { getCDNImageURL } from "@/data/images";

// The comedian avatar + name link shown beneath a special's video. Shared by the
// full special page (VideoWrapper) and the preview page so both stay identical.
export function ComedianLink({
  comedian,
  className,
}: {
  comedian: Pick<ComedianRow, "id" | "display_name" | "slug" | "about_img">;
  className?: string;
}) {
  return (
    <Link
      href={`/${comedian.slug}`}
      className={cn("flex items-center gap-1.5 group font-semibold", className)}
    >
      <div className="w-7 h-7 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
        {comedian.about_img ? (
          <Image
            width={28}
            height={28}
            alt={comedian.display_name}
            src={getCDNImageURL(comedian.about_img)}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-xs font-semibold text-gray-600">
            {comedian.display_name[0]}
          </div>
        )}
      </div>
      <span className="text-sm group-hover:underline">
        {comedian.display_name}
      </span>
    </Link>
  );
}
